<template>
    <svg
        class="inline-flex"
        viewBox="0 0 23 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.179 11.83a6.802 6.802 0 01-4.398 1.6c-3.745 0-6.781-3-6.781-6.7S3.036.03 6.78.03c1.679 0 3.215.603 4.399 1.6a6.802 6.802 0 014.398-1.6c3.745 0 6.781 3 6.781 6.7s-3.036 6.7-6.78 6.7a6.802 6.802 0 01-4.399-1.6z"
            fill="#ED0006"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.179 11.83a6.653 6.653 0 002.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.802 6.802 0 014.398-1.6c3.745 0 6.78 3 6.78 6.7s-3.035 6.7-6.78 6.7a6.802 6.802 0 01-4.398-1.6z"
            fill="#F9A000"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.179 11.83a6.653 6.653 0 002.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.653 6.653 0 00-2.382 5.1c0 2.042.924 3.87 2.382 5.1z"
            fill="#FF5E00"
        />
    </svg>
</template>